/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateFactoryShiftPatternDto,
  CreateShiftOverrideDto,
  FactoryCalendarDayDto,
  FactoryShiftOverrideDto,
  FactoryShiftPatternDto,
  FactoryShiftPatternsControllerGetCalendarParams,
  FactoryShiftPatternsControllerListOverridesParams,
  UpdateFactoryShiftPatternDto,
  UpdateShiftOverrideDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type factoryShiftPatternsControllerGetCalendarResponse200 = {
  data: FactoryCalendarDayDto[]
  status: 200
}

export type factoryShiftPatternsControllerGetCalendarResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerGetCalendarResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerGetCalendarResponseSuccess = (factoryShiftPatternsControllerGetCalendarResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerGetCalendarResponseError = (factoryShiftPatternsControllerGetCalendarResponse400 | factoryShiftPatternsControllerGetCalendarResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerGetCalendarResponse = (factoryShiftPatternsControllerGetCalendarResponseSuccess | factoryShiftPatternsControllerGetCalendarResponseError)

export const getFactoryShiftPatternsControllerGetCalendarUrl = (factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/shift-patterns/calendar?${stringifiedParams}` : `/factories/${factoryId}/shift-patterns/calendar`
}

/**
 * Resolves the active shift pattern per day (cycle rotation included) and applies overrides: public holidays drop slots, reduced_hours replaces net hours, overtime adds hours (slot-specific overtime on an off day synthesises a working slot with null times). Returns one entry per day in the range; days with no pattern coverage come back with is_working=false and no slots. Range is inclusive and limited to 400 days.
 * @summary Effective shift calendar for a factory over a date range
 */
export const factoryShiftPatternsControllerGetCalendar = async (factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerGetCalendarResponse> => {

  return customFetch<factoryShiftPatternsControllerGetCalendarResponse>(getFactoryShiftPatternsControllerGetCalendarUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFactoryShiftPatternsControllerGetCalendarQueryKey = (factoryId: string,
    params?: FactoryShiftPatternsControllerGetCalendarParams,) => {
    return [
    `/factories/${factoryId}/shift-patterns/calendar`, ...(params ? [params] : [])
    ] as const;
    }


export const getFactoryShiftPatternsControllerGetCalendarQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerGetCalendarQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>> = ({ signal }) => factoryShiftPatternsControllerGetCalendar(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoryShiftPatternsControllerGetCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>>
export type FactoryShiftPatternsControllerGetCalendarQueryError = void


export function useFactoryShiftPatternsControllerGetCalendar<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerGetCalendar<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerGetCalendar<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Effective shift calendar for a factory over a date range
 */

export function useFactoryShiftPatternsControllerGetCalendar<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoryShiftPatternsControllerGetCalendarQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Effective shift calendar for a factory over a date range
 */
export const prefetchFactoryShiftPatternsControllerGetCalendarQuery = async <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoryShiftPatternsControllerGetCalendarQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFactoryShiftPatternsControllerGetCalendarSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerGetCalendarQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>> = ({ signal }) => factoryShiftPatternsControllerGetCalendar(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoryShiftPatternsControllerGetCalendarSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>>
export type FactoryShiftPatternsControllerGetCalendarSuspenseQueryError = void


export function useFactoryShiftPatternsControllerGetCalendarSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerGetCalendarSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerGetCalendarSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Effective shift calendar for a factory over a date range
 */

export function useFactoryShiftPatternsControllerGetCalendarSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError = void>(
 factoryId: string,
    params: FactoryShiftPatternsControllerGetCalendarParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerGetCalendar>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoryShiftPatternsControllerGetCalendarSuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type factoryShiftPatternsControllerListPatternsResponse200 = {
  data: FactoryShiftPatternDto[]
  status: 200
}

export type factoryShiftPatternsControllerListPatternsResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerListPatternsResponseSuccess = (factoryShiftPatternsControllerListPatternsResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerListPatternsResponseError = (factoryShiftPatternsControllerListPatternsResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerListPatternsResponse = (factoryShiftPatternsControllerListPatternsResponseSuccess | factoryShiftPatternsControllerListPatternsResponseError)

export const getFactoryShiftPatternsControllerListPatternsUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/shift-patterns`
}

/**
 * Returns all shift patterns for the factory (including archived, flagged via is_archived), newest start_date first, each with its nested slots and occurrences.
 * @summary List shift patterns for a factory
 */
export const factoryShiftPatternsControllerListPatterns = async (factoryId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerListPatternsResponse> => {

  return customFetch<factoryShiftPatternsControllerListPatternsResponse>(getFactoryShiftPatternsControllerListPatternsUrl(factoryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFactoryShiftPatternsControllerListPatternsQueryKey = (factoryId: string,) => {
    return [
    `/factories/${factoryId}/shift-patterns`
    ] as const;
    }


export const getFactoryShiftPatternsControllerListPatternsQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerListPatternsQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>> = ({ signal }) => factoryShiftPatternsControllerListPatterns(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoryShiftPatternsControllerListPatternsQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>>
export type FactoryShiftPatternsControllerListPatternsQueryError = void


export function useFactoryShiftPatternsControllerListPatterns<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerListPatterns<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerListPatterns<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List shift patterns for a factory
 */

export function useFactoryShiftPatternsControllerListPatterns<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoryShiftPatternsControllerListPatternsQueryOptions(factoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List shift patterns for a factory
 */
export const prefetchFactoryShiftPatternsControllerListPatternsQuery = async <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 queryClient: QueryClient, factoryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoryShiftPatternsControllerListPatternsQueryOptions(factoryId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFactoryShiftPatternsControllerListPatternsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerListPatternsQueryKey(factoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>> = ({ signal }) => factoryShiftPatternsControllerListPatterns(factoryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoryShiftPatternsControllerListPatternsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>>
export type FactoryShiftPatternsControllerListPatternsSuspenseQueryError = void


export function useFactoryShiftPatternsControllerListPatternsSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerListPatternsSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerListPatternsSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List shift patterns for a factory
 */

export function useFactoryShiftPatternsControllerListPatternsSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError = void>(
 factoryId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListPatterns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoryShiftPatternsControllerListPatternsSuspenseQueryOptions(factoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type factoryShiftPatternsControllerCreatePatternResponse201 = {
  data: FactoryShiftPatternDto
  status: 201
}

export type factoryShiftPatternsControllerCreatePatternResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerCreatePatternResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerCreatePatternResponse409 = {
  data: void
  status: 409
}

export type factoryShiftPatternsControllerCreatePatternResponseSuccess = (factoryShiftPatternsControllerCreatePatternResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerCreatePatternResponseError = (factoryShiftPatternsControllerCreatePatternResponse400 | factoryShiftPatternsControllerCreatePatternResponse404 | factoryShiftPatternsControllerCreatePatternResponse409) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerCreatePatternResponse = (factoryShiftPatternsControllerCreatePatternResponseSuccess | factoryShiftPatternsControllerCreatePatternResponseError)

export const getFactoryShiftPatternsControllerCreatePatternUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/shift-patterns`
}

/**
 * Creates a shift pattern with its slots and occurrences in one document. Every occurrence week_index must be < cycle_weeks. The date range must not overlap another active (unarchived) pattern of the factory.
 * @summary Create a shift pattern
 */
export const factoryShiftPatternsControllerCreatePattern = async (factoryId: string,
    createFactoryShiftPatternDto: CreateFactoryShiftPatternDto, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerCreatePatternResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoryShiftPatternsControllerCreatePatternResponse>(getFactoryShiftPatternsControllerCreatePatternUrl(factoryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createFactoryShiftPatternDto)
  }
);}





export const getFactoryShiftPatternsControllerCreatePatternMutationKey = () => ['factoryShiftPatternsControllerCreatePattern'] as const;

export const getFactoryShiftPatternsControllerCreatePatternMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>, TError,FactoryShiftPatternsControllerCreatePatternMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>, TError,FactoryShiftPatternsControllerCreatePatternMutationVariables, TContext> => {

const mutationKey = getFactoryShiftPatternsControllerCreatePatternMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>, FactoryShiftPatternsControllerCreatePatternMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoryShiftPatternsControllerCreatePattern(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerCreatePatternMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>>
    export type FactoryShiftPatternsControllerCreatePatternMutationBody = CreateFactoryShiftPatternDto
    export type FactoryShiftPatternsControllerCreatePatternMutationError = void
    export type FactoryShiftPatternsControllerCreatePatternMutationVariables = {factoryId: string;data: CreateFactoryShiftPatternDto}

    /**
 * @summary Create a shift pattern
 */
export const useFactoryShiftPatternsControllerCreatePattern = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>, TError,FactoryShiftPatternsControllerCreatePatternMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerCreatePattern>>,
        TError,
        FactoryShiftPatternsControllerCreatePatternMutationVariables,
        TContext
      > => {
      return useMutation(getFactoryShiftPatternsControllerCreatePatternMutationOptions(options), queryClient);
    }
    export type factoryShiftPatternsControllerUpdatePatternResponse200 = {
  data: FactoryShiftPatternDto
  status: 200
}

export type factoryShiftPatternsControllerUpdatePatternResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerUpdatePatternResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerUpdatePatternResponse409 = {
  data: void
  status: 409
}

export type factoryShiftPatternsControllerUpdatePatternResponseSuccess = (factoryShiftPatternsControllerUpdatePatternResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerUpdatePatternResponseError = (factoryShiftPatternsControllerUpdatePatternResponse400 | factoryShiftPatternsControllerUpdatePatternResponse404 | factoryShiftPatternsControllerUpdatePatternResponse409) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerUpdatePatternResponse = (factoryShiftPatternsControllerUpdatePatternResponseSuccess | factoryShiftPatternsControllerUpdatePatternResponseError)

export const getFactoryShiftPatternsControllerUpdatePatternUrl = (factoryId: string,
    patternId: string,) => {




  return `/factories/${factoryId}/shift-patterns/${patternId}`
}

/**
 * Partial update. When slots are provided they replace the existing slots wholesale: slots are matched by slot_name so a matching slot keeps its slot_id (display_order updated, occurrences replaced); names missing from the payload are deleted. Archived patterns cannot be edited (409).
 * @summary Update a shift pattern
 */
export const factoryShiftPatternsControllerUpdatePattern = async (factoryId: string,
    patternId: string,
    updateFactoryShiftPatternDto: UpdateFactoryShiftPatternDto, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerUpdatePatternResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoryShiftPatternsControllerUpdatePatternResponse>(getFactoryShiftPatternsControllerUpdatePatternUrl(factoryId,patternId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFactoryShiftPatternDto)
  }
);}





export const getFactoryShiftPatternsControllerUpdatePatternMutationKey = () => ['factoryShiftPatternsControllerUpdatePattern'] as const;

export const getFactoryShiftPatternsControllerUpdatePatternMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>, TError,FactoryShiftPatternsControllerUpdatePatternMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>, TError,FactoryShiftPatternsControllerUpdatePatternMutationVariables, TContext> => {

const mutationKey = getFactoryShiftPatternsControllerUpdatePatternMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>, FactoryShiftPatternsControllerUpdatePatternMutationVariables> = (props) => {
          const {factoryId,patternId,data} = props ?? {};

          return  factoryShiftPatternsControllerUpdatePattern(factoryId,patternId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerUpdatePatternMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>>
    export type FactoryShiftPatternsControllerUpdatePatternMutationBody = UpdateFactoryShiftPatternDto
    export type FactoryShiftPatternsControllerUpdatePatternMutationError = void
    export type FactoryShiftPatternsControllerUpdatePatternMutationVariables = {factoryId: string;patternId: string;data: UpdateFactoryShiftPatternDto}

    /**
 * @summary Update a shift pattern
 */
export const useFactoryShiftPatternsControllerUpdatePattern = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>, TError,FactoryShiftPatternsControllerUpdatePatternMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdatePattern>>,
        TError,
        FactoryShiftPatternsControllerUpdatePatternMutationVariables,
        TContext
      > => {
      return useMutation(getFactoryShiftPatternsControllerUpdatePatternMutationOptions(options), queryClient);
    }
    export type factoryShiftPatternsControllerArchivePatternResponse201 = {
  data: FactoryShiftPatternDto
  status: 201
}

export type factoryShiftPatternsControllerArchivePatternResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerArchivePatternResponseSuccess = (factoryShiftPatternsControllerArchivePatternResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerArchivePatternResponseError = (factoryShiftPatternsControllerArchivePatternResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerArchivePatternResponse = (factoryShiftPatternsControllerArchivePatternResponseSuccess | factoryShiftPatternsControllerArchivePatternResponseError)

export const getFactoryShiftPatternsControllerArchivePatternUrl = (factoryId: string,
    patternId: string,) => {




  return `/factories/${factoryId}/shift-patterns/${patternId}/archive`
}

/**
 * Sets archived_at. Archived patterns drop out of the calendar and the non-overlap constraint, so a replacement pattern can be created over the same dates.
 * @summary Archive a shift pattern
 */
export const factoryShiftPatternsControllerArchivePattern = async (factoryId: string,
    patternId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerArchivePatternResponse> => {

  return customFetch<factoryShiftPatternsControllerArchivePatternResponse>(getFactoryShiftPatternsControllerArchivePatternUrl(factoryId,patternId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFactoryShiftPatternsControllerArchivePatternMutationKey = () => ['factoryShiftPatternsControllerArchivePattern'] as const;

export const getFactoryShiftPatternsControllerArchivePatternMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>, TError,FactoryShiftPatternsControllerArchivePatternMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>, TError,FactoryShiftPatternsControllerArchivePatternMutationVariables, TContext> => {

const mutationKey = getFactoryShiftPatternsControllerArchivePatternMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>, FactoryShiftPatternsControllerArchivePatternMutationVariables> = (props) => {
          const {factoryId,patternId} = props ?? {};

          return  factoryShiftPatternsControllerArchivePattern(factoryId,patternId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerArchivePatternMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>>

    export type FactoryShiftPatternsControllerArchivePatternMutationError = void
    export type FactoryShiftPatternsControllerArchivePatternMutationVariables = {factoryId: string;patternId: string}

    /**
 * @summary Archive a shift pattern
 */
export const useFactoryShiftPatternsControllerArchivePattern = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>, TError,FactoryShiftPatternsControllerArchivePatternMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerArchivePattern>>,
        TError,
        FactoryShiftPatternsControllerArchivePatternMutationVariables,
        TContext
      > => {
      return useMutation(getFactoryShiftPatternsControllerArchivePatternMutationOptions(options), queryClient);
    }
    export type factoryShiftPatternsControllerUnarchivePatternResponse201 = {
  data: FactoryShiftPatternDto
  status: 201
}

export type factoryShiftPatternsControllerUnarchivePatternResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerUnarchivePatternResponse409 = {
  data: void
  status: 409
}

export type factoryShiftPatternsControllerUnarchivePatternResponseSuccess = (factoryShiftPatternsControllerUnarchivePatternResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerUnarchivePatternResponseError = (factoryShiftPatternsControllerUnarchivePatternResponse404 | factoryShiftPatternsControllerUnarchivePatternResponse409) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerUnarchivePatternResponse = (factoryShiftPatternsControllerUnarchivePatternResponseSuccess | factoryShiftPatternsControllerUnarchivePatternResponseError)

export const getFactoryShiftPatternsControllerUnarchivePatternUrl = (factoryId: string,
    patternId: string,) => {




  return `/factories/${factoryId}/shift-patterns/${patternId}/unarchive`
}

/**
 * Clears archived_at, re-entering the pattern into the non-overlap constraint — conflicts with another active pattern return 409.
 * @summary Unarchive a shift pattern
 */
export const factoryShiftPatternsControllerUnarchivePattern = async (factoryId: string,
    patternId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerUnarchivePatternResponse> => {

  return customFetch<factoryShiftPatternsControllerUnarchivePatternResponse>(getFactoryShiftPatternsControllerUnarchivePatternUrl(factoryId,patternId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFactoryShiftPatternsControllerUnarchivePatternMutationKey = () => ['factoryShiftPatternsControllerUnarchivePattern'] as const;

export const getFactoryShiftPatternsControllerUnarchivePatternMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>, TError,FactoryShiftPatternsControllerUnarchivePatternMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>, TError,FactoryShiftPatternsControllerUnarchivePatternMutationVariables, TContext> => {

const mutationKey = getFactoryShiftPatternsControllerUnarchivePatternMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>, FactoryShiftPatternsControllerUnarchivePatternMutationVariables> = (props) => {
          const {factoryId,patternId} = props ?? {};

          return  factoryShiftPatternsControllerUnarchivePattern(factoryId,patternId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerUnarchivePatternMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>>

    export type FactoryShiftPatternsControllerUnarchivePatternMutationError = void
    export type FactoryShiftPatternsControllerUnarchivePatternMutationVariables = {factoryId: string;patternId: string}

    /**
 * @summary Unarchive a shift pattern
 */
export const useFactoryShiftPatternsControllerUnarchivePattern = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>, TError,FactoryShiftPatternsControllerUnarchivePatternMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerUnarchivePattern>>,
        TError,
        FactoryShiftPatternsControllerUnarchivePatternMutationVariables,
        TContext
      > => {
      return useMutation(getFactoryShiftPatternsControllerUnarchivePatternMutationOptions(options), queryClient);
    }
    export type factoryShiftPatternsControllerListOverridesResponse200 = {
  data: FactoryShiftOverrideDto[]
  status: 200
}

export type factoryShiftPatternsControllerListOverridesResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerListOverridesResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerListOverridesResponseSuccess = (factoryShiftPatternsControllerListOverridesResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerListOverridesResponseError = (factoryShiftPatternsControllerListOverridesResponse400 | factoryShiftPatternsControllerListOverridesResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerListOverridesResponse = (factoryShiftPatternsControllerListOverridesResponseSuccess | factoryShiftPatternsControllerListOverridesResponseError)

export const getFactoryShiftPatternsControllerListOverridesUrl = (factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/factories/${factoryId}/shift-overrides?${stringifiedParams}` : `/factories/${factoryId}/shift-overrides`
}

/**
 * Returns unarchived overrides, ordered by start_date. Pass from and to (both or neither) to keep only overrides intersecting that inclusive range.
 * @summary List shift overrides for a factory
 */
export const factoryShiftPatternsControllerListOverrides = async (factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerListOverridesResponse> => {

  return customFetch<factoryShiftPatternsControllerListOverridesResponse>(getFactoryShiftPatternsControllerListOverridesUrl(factoryId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFactoryShiftPatternsControllerListOverridesQueryKey = (factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams,) => {
    return [
    `/factories/${factoryId}/shift-overrides`, ...(params ? [params] : [])
    ] as const;
    }


export const getFactoryShiftPatternsControllerListOverridesQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerListOverridesQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>> = ({ signal }) => factoryShiftPatternsControllerListOverrides(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: factoryId !== null && factoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoryShiftPatternsControllerListOverridesQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>>
export type FactoryShiftPatternsControllerListOverridesQueryError = void


export function useFactoryShiftPatternsControllerListOverrides<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params: undefined |  FactoryShiftPatternsControllerListOverridesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerListOverrides<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>,
          TError,
          Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerListOverrides<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List shift overrides for a factory
 */

export function useFactoryShiftPatternsControllerListOverrides<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoryShiftPatternsControllerListOverridesQueryOptions(factoryId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List shift overrides for a factory
 */
export const prefetchFactoryShiftPatternsControllerListOverridesQuery = async <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 queryClient: QueryClient, factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getFactoryShiftPatternsControllerListOverridesQueryOptions(factoryId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getFactoryShiftPatternsControllerListOverridesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFactoryShiftPatternsControllerListOverridesQueryKey(factoryId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>> = ({ signal }) => factoryShiftPatternsControllerListOverrides(factoryId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FactoryShiftPatternsControllerListOverridesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>>
export type FactoryShiftPatternsControllerListOverridesSuspenseQueryError = void


export function useFactoryShiftPatternsControllerListOverridesSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params: undefined |  FactoryShiftPatternsControllerListOverridesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerListOverridesSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFactoryShiftPatternsControllerListOverridesSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List shift overrides for a factory
 */

export function useFactoryShiftPatternsControllerListOverridesSuspense<TData = Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError = void>(
 factoryId: string,
    params?: FactoryShiftPatternsControllerListOverridesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerListOverrides>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFactoryShiftPatternsControllerListOverridesSuspenseQueryOptions(factoryId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type factoryShiftPatternsControllerCreateOverrideResponse201 = {
  data: FactoryShiftOverrideDto
  status: 201
}

export type factoryShiftPatternsControllerCreateOverrideResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerCreateOverrideResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerCreateOverrideResponseSuccess = (factoryShiftPatternsControllerCreateOverrideResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerCreateOverrideResponseError = (factoryShiftPatternsControllerCreateOverrideResponse400 | factoryShiftPatternsControllerCreateOverrideResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerCreateOverrideResponse = (factoryShiftPatternsControllerCreateOverrideResponseSuccess | factoryShiftPatternsControllerCreateOverrideResponseError)

export const getFactoryShiftPatternsControllerCreateOverrideUrl = (factoryId: string,) => {




  return `/factories/${factoryId}/shift-overrides`
}

/**
 * Flags a date (or inclusive range) differently to the shift pattern: public_holiday (no hours), overtime (hours added; on an off day a slot-specific override synthesises a working day), or reduced_hours (hours replaced). end_date defaults to start_date. slot_id must belong to a shift pattern of this factory.
 * @summary Create a shift override
 */
export const factoryShiftPatternsControllerCreateOverride = async (factoryId: string,
    createShiftOverrideDto: CreateShiftOverrideDto, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerCreateOverrideResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoryShiftPatternsControllerCreateOverrideResponse>(getFactoryShiftPatternsControllerCreateOverrideUrl(factoryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createShiftOverrideDto)
  }
);}





export const getFactoryShiftPatternsControllerCreateOverrideMutationKey = () => ['factoryShiftPatternsControllerCreateOverride'] as const;

export const getFactoryShiftPatternsControllerCreateOverrideMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>, TError,FactoryShiftPatternsControllerCreateOverrideMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>, TError,FactoryShiftPatternsControllerCreateOverrideMutationVariables, TContext> => {

const mutationKey = getFactoryShiftPatternsControllerCreateOverrideMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>, FactoryShiftPatternsControllerCreateOverrideMutationVariables> = (props) => {
          const {factoryId,data} = props ?? {};

          return  factoryShiftPatternsControllerCreateOverride(factoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerCreateOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>>
    export type FactoryShiftPatternsControllerCreateOverrideMutationBody = CreateShiftOverrideDto
    export type FactoryShiftPatternsControllerCreateOverrideMutationError = void
    export type FactoryShiftPatternsControllerCreateOverrideMutationVariables = {factoryId: string;data: CreateShiftOverrideDto}

    /**
 * @summary Create a shift override
 */
export const useFactoryShiftPatternsControllerCreateOverride = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>, TError,FactoryShiftPatternsControllerCreateOverrideMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerCreateOverride>>,
        TError,
        FactoryShiftPatternsControllerCreateOverrideMutationVariables,
        TContext
      > => {
      return useMutation(getFactoryShiftPatternsControllerCreateOverrideMutationOptions(options), queryClient);
    }
    export type factoryShiftPatternsControllerUpdateOverrideResponse200 = {
  data: FactoryShiftOverrideDto
  status: 200
}

export type factoryShiftPatternsControllerUpdateOverrideResponse400 = {
  data: void
  status: 400
}

export type factoryShiftPatternsControllerUpdateOverrideResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerUpdateOverrideResponse409 = {
  data: void
  status: 409
}

export type factoryShiftPatternsControllerUpdateOverrideResponseSuccess = (factoryShiftPatternsControllerUpdateOverrideResponse200) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerUpdateOverrideResponseError = (factoryShiftPatternsControllerUpdateOverrideResponse400 | factoryShiftPatternsControllerUpdateOverrideResponse404 | factoryShiftPatternsControllerUpdateOverrideResponse409) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerUpdateOverrideResponse = (factoryShiftPatternsControllerUpdateOverrideResponseSuccess | factoryShiftPatternsControllerUpdateOverrideResponseError)

export const getFactoryShiftPatternsControllerUpdateOverrideUrl = (factoryId: string,
    overrideId: string,) => {




  return `/factories/${factoryId}/shift-overrides/${overrideId}`
}

/**
 * Partial update with the same validation as create (applied to the merged result). Archived overrides cannot be edited (409).
 * @summary Update a shift override
 */
export const factoryShiftPatternsControllerUpdateOverride = async (factoryId: string,
    overrideId: string,
    updateShiftOverrideDto: UpdateShiftOverrideDto, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerUpdateOverrideResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<factoryShiftPatternsControllerUpdateOverrideResponse>(getFactoryShiftPatternsControllerUpdateOverrideUrl(factoryId,overrideId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateShiftOverrideDto)
  }
);}





export const getFactoryShiftPatternsControllerUpdateOverrideMutationKey = () => ['factoryShiftPatternsControllerUpdateOverride'] as const;

export const getFactoryShiftPatternsControllerUpdateOverrideMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>, TError,FactoryShiftPatternsControllerUpdateOverrideMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>, TError,FactoryShiftPatternsControllerUpdateOverrideMutationVariables, TContext> => {

const mutationKey = getFactoryShiftPatternsControllerUpdateOverrideMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>, FactoryShiftPatternsControllerUpdateOverrideMutationVariables> = (props) => {
          const {factoryId,overrideId,data} = props ?? {};

          return  factoryShiftPatternsControllerUpdateOverride(factoryId,overrideId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerUpdateOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>>
    export type FactoryShiftPatternsControllerUpdateOverrideMutationBody = UpdateShiftOverrideDto
    export type FactoryShiftPatternsControllerUpdateOverrideMutationError = void
    export type FactoryShiftPatternsControllerUpdateOverrideMutationVariables = {factoryId: string;overrideId: string;data: UpdateShiftOverrideDto}

    /**
 * @summary Update a shift override
 */
export const useFactoryShiftPatternsControllerUpdateOverride = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>, TError,FactoryShiftPatternsControllerUpdateOverrideMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerUpdateOverride>>,
        TError,
        FactoryShiftPatternsControllerUpdateOverrideMutationVariables,
        TContext
      > => {
      return useMutation(getFactoryShiftPatternsControllerUpdateOverrideMutationOptions(options), queryClient);
    }
    export type factoryShiftPatternsControllerArchiveOverrideResponse201 = {
  data: FactoryShiftOverrideDto
  status: 201
}

export type factoryShiftPatternsControllerArchiveOverrideResponse404 = {
  data: void
  status: 404
}

export type factoryShiftPatternsControllerArchiveOverrideResponseSuccess = (factoryShiftPatternsControllerArchiveOverrideResponse201) & {
  headers: Headers;
};
export type factoryShiftPatternsControllerArchiveOverrideResponseError = (factoryShiftPatternsControllerArchiveOverrideResponse404) & {
  headers: Headers;
};

export type factoryShiftPatternsControllerArchiveOverrideResponse = (factoryShiftPatternsControllerArchiveOverrideResponseSuccess | factoryShiftPatternsControllerArchiveOverrideResponseError)

export const getFactoryShiftPatternsControllerArchiveOverrideUrl = (factoryId: string,
    overrideId: string,) => {




  return `/factories/${factoryId}/shift-overrides/${overrideId}/archive`
}

/**
 * Sets archived_at; the override no longer affects the calendar.
 * @summary Archive a shift override
 */
export const factoryShiftPatternsControllerArchiveOverride = async (factoryId: string,
    overrideId: string, options?: Parameters<typeof customFetch>[1]): Promise<factoryShiftPatternsControllerArchiveOverrideResponse> => {

  return customFetch<factoryShiftPatternsControllerArchiveOverrideResponse>(getFactoryShiftPatternsControllerArchiveOverrideUrl(factoryId,overrideId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFactoryShiftPatternsControllerArchiveOverrideMutationKey = () => ['factoryShiftPatternsControllerArchiveOverride'] as const;

export const getFactoryShiftPatternsControllerArchiveOverrideMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>, TError,FactoryShiftPatternsControllerArchiveOverrideMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>, TError,FactoryShiftPatternsControllerArchiveOverrideMutationVariables, TContext> => {

const mutationKey = getFactoryShiftPatternsControllerArchiveOverrideMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>, FactoryShiftPatternsControllerArchiveOverrideMutationVariables> = (props) => {
          const {factoryId,overrideId} = props ?? {};

          return  factoryShiftPatternsControllerArchiveOverride(factoryId,overrideId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FactoryShiftPatternsControllerArchiveOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>>

    export type FactoryShiftPatternsControllerArchiveOverrideMutationError = void
    export type FactoryShiftPatternsControllerArchiveOverrideMutationVariables = {factoryId: string;overrideId: string}

    /**
 * @summary Archive a shift override
 */
export const useFactoryShiftPatternsControllerArchiveOverride = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>, TError,FactoryShiftPatternsControllerArchiveOverrideMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof factoryShiftPatternsControllerArchiveOverride>>,
        TError,
        FactoryShiftPatternsControllerArchiveOverrideMutationVariables,
        TContext
      > => {
      return useMutation(getFactoryShiftPatternsControllerArchiveOverrideMutationOptions(options), queryClient);
    }
